import { i18nTranslate, Enterprise } from "@ctra/i18n";
import { useGoogleAnalytics } from "@ctra/analytics";

import { StepConfig, OnboardingGALabels } from "../../typings";

import styles from "../../components/Onboarding/Onboarding.module.less";

const { buttons: buttonsContent } = Enterprise.onboarding;

/**
 * Hook for exposing step utils
 * @returns an object containing utils used for making a step
 */
export const useOnboardingStep = (): {
  makeStep: (config: StepConfig) => Record<string, unknown>;
  previousButton: () => Record<string, unknown>;
  nextButtton: () => Record<string, unknown>;
  doneButtton: () => Record<string, unknown>;
} => {
  const { trackEvent } = useGoogleAnalytics();

  const previousButton = (): Record<string, unknown> => ({
    classes: styles.Button,
    text: i18nTranslate(buttonsContent.back),
    type: "back"
  });

  const nextButtton = (): Record<string, unknown> => ({
    classes: styles.Button,
    text: i18nTranslate(buttonsContent.next),
    type: "next"
  });

  const doneButtton = (): Record<string, unknown> => ({
    classes: styles.Button,
    text: i18nTranslate(buttonsContent.done),
    type: "next"
  });

  const makeStep = (config: StepConfig): Record<string, unknown> => {
    const { title, text, image, action, ...rest } = config;

    /**
     * Reset falsy values to empty strings. This prevents the display of undefined for null/undefined content
     */
    const textContent = text ?? "";
    const imageContent = image ? `<img src=${image} />` : "";
    const actionContent = action ? `<p>${action}</p>` : "";

    return {
      buttons: [previousButton(), nextButtton()],
      text:
        textContent || imageContent || actionContent
          ? `<div class="ContentWrapper">${textContent}${imageContent}${actionContent}</div>`
          : null,
      title,
      when: {
        show: () => {
          /* istanbul ignore next */
          trackEvent(title as string, { label: OnboardingGALabels.step });
        }
      },
      ...rest
    };
  };

  return { makeStep, previousButton, nextButtton, doneButtton };
};
